<div class="modal-header">
  <div class="modal-header-x" (click)="bsModalRef.hide()">
    <i-feather name="x"></i-feather>
  </div>
</div>
<poll-details [postHashHex]="postHashHex" [bsModalRef]="bsModalRef"></poll-details>
